module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "foreword"
    }
  }, [_c('h1'), _vm._v(" "), _c('p', [_vm._v("The Moving Finger writes and having writ moves on Nor all thy piety nor wit can move it back to cancel half a line. Nor all thy tears wash out a word of it.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('strong', [_vm._v("From the Rubayat of Omar Khyam")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bdc24252","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0002.vue
// module id = 78
// module chunks = 0